<template>
  <div v-redirect-if-no-permission:RESERVATIONS>
    <loading-component :value="loading_payment"></loading-component>
    <v-card>
      <v-card-title>
        <v-layout>
          <!-- <v-flex xs9 style="padding: 8px">
            <v-select
              label="Select Status"
              multiple
              :items="['PENDING', 'STAGING', 'APPROVED', 'PAID']"
              v-model="payment_status"
            ></v-select>
          </v-flex> -->
          <v-flex xs6 style="padding: 8px">
            <choose-date clearable :label="$t('dispatching.reservationsList.filterByDay')" v-model="date_filter"></choose-date>
          </v-flex>
          <!-- <v-flex xs6 style="padding: 8px">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              @keyup.enter="getData"
            ></v-text-field>
          </v-flex> -->
        </v-layout>
      </v-card-title>
      <v-data-table :url="url" :headers="headers" :items="data" :pagination.sync="pagination" :total-items="totalItems"
        :rows-per-page-items="[5, 10, 15, 25, 100, 300]" :loading="loading">
        <template v-slot:items="props">
          <tr @click="expandTable(props)" :class="{ row: props.item.transformed }">
            <td class="text-xs-center">{{ props.item.id }}</td>
            <td class="text-xs-center">
              {{ props.item.passenger_full_name }}
            </td>
            <td class="text-xs-center">
              {{ formatDate(props.item.datetime) }}
            </td>
            <td class="text-xs-center">
              {{ props.item.room_number }}
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.landmark_pickup">{{
                props.item.landmark_pickup
              }}</span>
              <span v-else-if="props.item.pick_up_location_details">{{
                props.item.pick_up_location_details
              }}</span>
              <span v-else>{{ props.item.pick_up_location_name }}</span>
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.landmark_dropoff">{{
                props.item.landmark_dropoff
              }}</span>
              <span v-else-if="props.item.pull_down_location_details">{{
                props.item.pull_down_location_details
              }}</span>
              <span v-else>{{ props.item.pull_down_location_name }}</span>
            </td>
            <td class="text-xs-center">
              {{ props.item.vehicle_type }}
            </td>

            <td class="text-xs-center">
              <span v-if="props.item.status === 'PAX_CANCELLED'">
                {{ $t("dispatching.reservationsList.cancelledByCustomer") }}
              </span>
              <span v-else-if="props.item.status === 'CAPTAIN_CANCELLED'">
                {{ $t("dispatching.reservationsList.cancelledByDriver") }}
              </span>
              <span v-else-if=" ['SYSTEM_CANCELLED', 'REJECTED'].includes(props.item.status) && !props.item.system_cancellation_reason">
                {{ $t("dispatching.reservationsList.cancelledByCC") }}
              </span>
               <span v-else-if=" ['SYSTEM_CANCELLED', 'REJECTED'].includes(props.item.status) && props.item.system_cancellation_reason">
                {{ $t("dispatching.reservationsList.cancelledBySystem") }}
              </span>
              <!-- <span v-else>
                {{ props.item.status }}
              </span> -->
              <span v-else-if="props.item.status === 'PENDING'">
                {{ $t("dispatching.reservationsList.waitingForDispatching") }}
              </span>
              <span v-else-if="
                props.item.status === 'APPROVED' || props.item.status === 'ACCEPTED'
              ">
                {{ $t("dispatching.reservationsList.orderDispatched") }}
              </span>
              <span v-else-if="props.item.status === 'STARTED'">
                {{ $t("dispatching.reservationsList.driverOnTheWay") }}
              </span>
              <span v-else-if="props.item.status === 'ARRIVED'"> {{ $t("dispatching.reservationsList.arrivedToPickup") }} </span>
              <span v-else-if="props.item.status === 'PICKED_UP'"> {{ $t("dispatching.reservationsList.tripStarted") }} </span><span
                v-else-if="props.item.status === 'DONE'"> {{ $t("dispatching.reservationsList.arrivedToDropoff") }} </span><span
                v-else-if="props.item.status === 'PAID'"> {{ $t("dispatching.reservationsList.successful") }} </span>
              <span v-else-if="props.item.status === 'DELETED'"> {{ $t("dispatching.reservationsList.cancelled") }} </span>
              <span v-else>
                {{ props.item.status }}
              </span>
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.taxi_number">{{ props.item.taxi_number }}</span>
              <span v-else>{{ $t("common.noData") }}</span>
            </td>
            <!-- <td class="text-xs-center">{{ props.item.status }}</td> -->
            <td class="text-xs-center">
              <span style="color: red" v-if="props.item.transformed">{{ $t("dispatching.reservationsList.transformed") }}</span>
              <span style="color: green" v-else>{{ $t("dispatching.reservationsList.normal") }}</span>
            </td>
            <td class="text-xs-center" @click.stop>
              <order-actions :data="props.item" @cancelled="getData" />
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-container>
              <v-layout row wrap>
                <div class="constraint" v-if="props.item.seats">
                  <img :src="require(`../assets/constraints/person.svg`)" class="constraint-icon float-left" />
                  <label class="name">{{
                    props.item.seats > 1 ? $t("dispatching.reservationsList.passengers", { count: props.item.seats }) : $t("dispatching.reservationsList.passenger", { count: props.item.seats })
                  }}</label>
                </div>
                <div class="constraint" v-if="props.item.encompt">
                  <img :src="require(`../assets/constraints/${constraints.en_compt}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">{{ $t("dispatching.reservationsList.encompte") }}</label>
                </div>
                <div class="constraint" v-if="props.item.low_car">
                  <img v-if="props.item.low_car" :src="require(`../assets/constraints/${constraints.low_car}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">{{ $t("dispatching.reservationsList.lowCar") }}</label>
                </div>
                <div class="constraint" v-if="props.item.wheelchair">
                  <img v-if="props.item.wheelchair"
                    :src="require(`../assets/constraints/${constraints.wheelchair}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">{{ $t("dispatching.reservationsList.wheelchair") }}</label>
                </div>
                <div class="constraint" v-if="props.item.pets">
                  <img v-if="props.item.pets" :src="require(`../assets/constraints/${constraints.animal}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">{{ $t("dispatching.reservationsList.pets") }}</label>
                </div>
                <div class="constraint" v-if="props.item.amex">
                  <img v-if="props.item.amex" :src="require(`../assets/constraints/${constraints.amex}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">AMEX</label>
                </div>
                <div class="constraint" v-if="props.item.mad">
                  <img v-if="props.item.mad" :src="require(`../assets/constraints/${constraints.mad}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">mad</label>
                </div>
                <div class="constraint" v-if="props.item.test">
                  <img v-if="props.item.test" :src="require(`../assets/constraints/${constraints.test}.svg`)"
                    class="constraint-icon float-left" />
                  <label class="name">test</label>
                </div>
                <v-flex xs12 style="margin-bottom: 12px"><b>{{ $t("dispatching.reservationsList.comments") }} </b> {{ props.item.notes }}</v-flex>
                <!-- <v-flex xs12>{{ props }}</v-flex> -->
                <v-flex xs12><b>{{ $t("dispatching.reservationsList.creationDate") }} </b>{{ props.item.created_at }}</v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import ConfirmDialog from "@/components/monaco/ConfirmDialog";
import OrderActions from "@/components/dispatching/OrderActions";

export default {
  name: "Reservations",
  title() {
    return this.$t("dispatching.reservationsList.title");
  },
  components: {
    ConfirmDialog,
    ChooseDate,
    LoadingComponent,
    ChooseCaptainsMulti,
    OrderActions,
  },
  data() {
    return {
      start: "",
      end: "",
      from: "",
      approve_one_confirm_dialog: false,
      approve_confirm_dialog: false,
      model: {
        actual_paid: {
          exist: false,
          amount: null,
        },
        paid_using: null,
      },
      constraints: {
        amex: "amex",
        animal: "animal",
        low_car: "low_car",
        en_compt: "en_compt",
        person: "person",
        wheelchair: "wheelchair",
        mad: "mad",
        test: "test",
      },
      select_date: false,
      date: null,
      date_filter: "",
      valid: false,
      url: "booking",
      captains: [],
      loading_payment: false,
      payment_status: ["PENDING"],
      data: [],
      loading: false,
      search: "",
      items: [],
      totalItems: 0,
      pagination: {
        sortBy: "id",
        rowsPerPage: 300,
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: "ID", value: "id", sortable: false, align: "center" },
        {
          text: this.$t("dispatching.reservationsList.headers.clientName"),
          value: "captain_name",
          sortable: false,
          align: "center",
        },
        { text: this.$t("dispatching.reservationsList.headers.time"), value: "Datetime", sortable: false, align: "center" },
        {
          text: this.$t("dispatching.reservationsList.headers.roomNumber"),
          value: "room_number",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("dispatching.reservationsList.headers.pickup"),
          value: "pickup_landmark",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("dispatching.reservationsList.headers.dropoff"),
          value: "dropoff_landmark",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("dispatching.reservationsList.headers.vehicle"),
          value: "vehicle_type",
          sortable: false,
          align: "center",
        },
        { text: this.$t("common.status"), value: "status", sortable: false, align: "center" },
        {
          text: this.$t("dispatching.reservationsList.headers.taxiNumber"),
          value: "taxi_number",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("dispatching.reservationsList.headers.type"),
          value: "transformed",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    date_filter() {
      console.log(this.date_filter);
      this.getData();
    },
  },
  mounted() {
    var now = moment().format("YYYY-MM-DD ");
    this.start = moment(now).format("YYYY-MM-DD HH:mm:ss");
    this.end = moment(now).format("YYYY-MM-DD HH:mm:ss").replace("00:00:00", "23:59:59");
    this.getData();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("HH[h]m - DD/MM/YYYY");
    },
    formatDateTime(time) {
      return moment(time).format("HH[h]m - DD[/]MM[/]YYYY");
    },
    expandTable(row) {
      // if (row.item.status === "PAID" || row.item.status === "APPROVED")
      row.expanded = !row.expanded;
    },

    getData() {
      this.loading = true;
      const params = new URLSearchParams();
      if (this.date_filter != "Invalid date" && this.date_filter) {
        this.start = moment(this.date_filter).format("YYYY-MM-DD HH:mm:ss");

        this.end = moment(this.date_filter)
          .format("YYYY-MM-DD HH:mm:ss")
          .replace("00:00:00", "23:59:59");

        console.log("START");
        console.log(this.start);
        console.log(this.end);
      }
      params.append("page", this.pagination.page);
      params.append("perPage", String(this.pagination.rowsPerPage));
      // params.append("sortBy", String(this.pagination.sortBy));
      // params.append("descending", String(this.pagination.descending));
      params.append("time", "RESERVATION");
      params.append("sortBy", "id");
      params.append("descending", true);
      params.append("from", this.start);
      params.append("to", this.end);
      params.append("reservations", true);

      // params.append("search", String(this.search));
      // params.append("status", String(this.payment_status));
      // if (this.date_filter) params.append("weekday", String(this.date_filter));
      this.axios
        .get(this.url, { params })
        .then((res) => {
          console.log("data");
          console.log(res);
          this.data = res.data.data.data;
          this.totalItems = res.data.data.total;
          this.pagination.rowsPerPage = Number(res.data.data.per_page);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.constraint {
  border: 1px;
  border-style: solid;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 1px 1px;
  width: max-content;
  align-items: center;
  display: flex;
  margin-right: 10px;
  margin-bottom: 15px;
}

.name {
  margin-left: 5px;
}

.test {
  color: red;
}
</style>
